<template>
  <div class="animated fadeIn">
    <div class="cardheading">
      <h4><i class="fa fa-trophy"></i><span class="ml-1">LeaderBoard Manipulation</span></h4>

      <div class="row">
        <div class="col">
          <label for="phone">Phone:</label><br>
          <input type="text" id="phone" v-model="phone">
        </div>

        <div class="col">
          <label for="score">Score:</label><br>
          <input type="text" id="score" v-model="score">
        </div>

      </div>

      <div class="row">
        <div class="col">
          <div class="alert alert-warning" role="alert">
            the phone is {{phone}}
          </div>
        </div>

        <div class="col">
          <div class="alert alert-warning" role="alert">
            the score is {{score}}
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col">
          <button v-on:click="updateScore" type="button" class="btn btn-square btn-dark">Update</button>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import axios from "axios";
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;

export default {
  name: "LeaderBoardManipulation",

  data(){
    return {
      phone: "",
      score: "",
    };
  },

  methods: {
    updateScore() {
      console.log("ss");
      const payload = {
        phone: this.phone,
        score: this.score,
      };

      axios.post(`${ADMIN_URL}/leaderboard-manipulate-score/`, payload)
          .then(response => {
            console.log('Response leaderboard manipulation  ', response.data);
            this.$swal("Result", response.data, "success");
          }).catch(error => {
             this.$swal("Error", error, "error");

      })
    }
  },

}
</script>

<style scoped>

</style>
